import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ElementRef, ViewChild} from '@angular/core';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-send-sponsoring-email',
    templateUrl: './send-sponsoring-email.component.html',
    styleUrls: ['./send-sponsoring-email.component.scss'],
    standalone: false
})
export class SendSponsoringEmailComponent implements OnInit {
  sendEmailForm: FormGroup;
  userID: number;
  codesList: any;

  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  codeCtrl = new FormControl();
  filteredCodes: Observable<string[]>;
  codes: any;
  allCodes: any;
  codesIds: Array<number>;

  @ViewChild('codeInput') codeInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  invalidCodes: boolean;

  constructor(public dialog: MatDialog,
              private dataService: DataService,
              public utils: UtilsService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<SendSponsoringEmailComponent>,
              private authService: AuthService) {
                this.invalidCodes = false;
                this.codesIds = new Array<number>();
                this.userID = this.authService.getUserData().id;
                this.codesList = this.data.codesList;
                const codesTemp = [];
                const allCodesTemp = [];
                for (let index = 0; index < this.codesList.length; index++) {
                  const element = this.codesList[index];
                  allCodesTemp.push(element.code);
                  codesTemp.push(element.code);
                }
                this.codes = codesTemp;
                this.allCodes = allCodesTemp;
                this.filteredCodes = this.codeCtrl.valueChanges.pipe(
                  startWith(null),
                  map((code: string | null) => code ? this._filter(code) : this.allCodes.slice()));
               }

  ngOnInit(): void {
    this.sendEmailForm = new FormGroup({
      firstName: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      lastName: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)]),
    });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (this.codes.includes(value.trim())) {
        this.codes.push(value.trim());
      }
    }

    if (input) {
      input.value = '';
    }

    this.codeCtrl.setValue(null);

  }

  remove(code: string): void {
    const index = this.codes.indexOf(code);

    if (index >= 0) {
      this.codes.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.codes.includes(event.option.viewValue.trim())) {
      this.codes.push(event.option.viewValue);
    }
    this.codeInput.nativeElement.value = '';
    this.codeCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allCodes.filter(code => code.toLowerCase().indexOf(filterValue) === 0);
  }

  closeDialog() {
    if (this.sendEmailForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  ngDoCheck() {
    if (this.codes.length > 0) {
      this.invalidCodes = false;
    } else {
      this.invalidCodes = true;
    }
  }

  onSubmit() {
    if (this.codes.length > 0) {
    } else {
      this.invalidCodes = true;
      return;
    }
    if (this.sendEmailForm.valid) {
      for (let index = 0; index < this.data.codesList.length; index++) {
        const element = this.codesList[index];
        for (let index = 0; index < this.codes.length; index++) {
          const item = this.codes[index];
          if (item === element.code) {
            this.codesIds.push(element.id);
          }
        }
      }
      const payload = {
        promotionIds: this.codesIds,
        lastName: this.sendEmailForm.get('lastName').value,
        firstName : this.sendEmailForm.get('firstName').value,
        email : this.sendEmailForm.get('email').value,
      };
      this.dataService.post('promotionCode/SendPromotionCodes', payload).then((data) => {
        this.dialog.closeAll();
        if (data.statusCode === 200) {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Emails have been sent successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });
    } else {
      this.sendEmailForm.markAllAsTouched();
    }
  }

}
